module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/middle-done-9a107dd03c2684799aba339c68fca6d6.svg";